var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenCircleCheck = function SvgGreenCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#7B886D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.578 29.134a1.2 1.2 0 0 1-.863-.358l-4.857-4.936a1.247 1.247 0 0 1 .064-1.675 1.205 1.205 0 0 1 1.649-.065l4.006 4.06 8.852-8.996a1.2 1.2 0 0 1 1.649.065 1.246 1.246 0 0 1 .064 1.675l-9.714 9.872a1.2 1.2 0 0 1-.85.358"
  })));
};
export default SvgGreenCircleCheck;